import styles from './InfoBox.module.scss';
import { UI_RichText } from 'ui/components/1-atoms/RichText/RichText';
import ColorOptions from 'helpers/types';
import classNames from 'classnames';

export interface UI_InfoBoxProps {
	content: string;
	color?: ColorOptions;
	variant?: 'filled' | 'outlined';
	className?: string;
	accentColor?: ColorOptions | 'light';
}

export const UI_InfoBox: React.FC<UI_InfoBoxProps> = ({ content, color = 'blue', variant = 'filled', className, accentColor }) => {
	return (
		<div
			className={classNames(
				styles.InfoBox,
				styles[`u-infoBoxColor___${color}`],
				accentColor && styles[`u-infoBoxAccentColor___${accentColor}`],
				variant === 'outlined' ? styles['InfoBox___outlined'] : styles['InfoBox___filled'],
				className,
			)}
		>
			<UI_RichText content={content} />
		</div>
	);
};
